export default __webpack_public_path__ + "static/media/img-step-a-bg-3@3x.56a3f812.jpg";